import React from "react";
import { useTranslation } from "react-i18next";
import Pagination from "react-js-pagination";
import AppliedApplicationListItem from "./ListItem/AppliedApplicationListItem";
const AppliedApplicationList = (props) => {
  const { t } = useTranslation();

  const onPageChanged = (page) => {
    props.onPageChanged(page);
  };

  const getListingSummary = () => {
    const { listSummaryObject } = props;
    const { totalElements } = listSummaryObject;
  
    if (totalElements === 0) {
      return <h2 className="text-center">{t("Applications.NoResultsFound")}</h2>;
    }
  
    return (
      <>
        {totalElements}{" "}
        {totalElements === 1 ? t("Application.Found") : t("Applications.Found")}
        <br />
        <br />
      </>
    );
  };

  const getAppliedApplicationList = (listSummaryObject) => {
    const { handleSubmitWithdraw, handleSubmitReviewDocument, candidateId } = props;

    return listSummaryObject.content.map((applied, i) => 
        <AppliedApplicationListItem applied={applied} key={i} handleSubmitWithdraw={handleSubmitWithdraw} 
        handleSubmitReviewDocument={handleSubmitReviewDocument} candidateId={candidateId} />
    );
  };

  const { listSummaryObject } = props;

  return (
    <div className="clearfix dashboard-list dashboard-list--application-drafts">
      <div className="dashboard-list--header">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">{getListingSummary()}</div>
          </div>
        </div>
      </div>
      { listSummaryObject.content.length && (
        <div className="dashboard-list--inner">
          <div className="container">{listSummaryObject && listSummaryObject.content.length ? getAppliedApplicationList(listSummaryObject) : null}</div>
        </div>
      )}
      {listSummaryObject.totalPages > 1 ? (
        <div className="dashboard-list--footer">
          <div className="container">
            <div className="pager-wrapper clearfix">
              <Pagination activePage={listSummaryObject.number + 1} prevPageText="Prev" nextPageText="Next" itemsCountPerPage={listSummaryObject.size} totalItemsCount={listSummaryObject.totalElements} onChange={onPageChanged} />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
};

export default AppliedApplicationList;